module.exports = __webpack_public_path__ + "img/layout1_preview.68b95d59.jpg";